var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import ClassNames from "classnames";
import { nl2br, isStringMarkdown } from "@riseart/fe-utils";
import { Button } from "../../button/Button";
import { Markdown } from "../../markdown/Markdown";
import { expandableTextCls, expandableTextHideCls, expandableTextButtonsWrapperCls } from "./Text.less";
function splitText(text) {
  var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var splitAtCharacter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
  var splitAtCharacterCorrection = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "before";
  var trimWhitespaces = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  if (!text || length <= 0 || text.length <= length) {
    return [text || ""];
  }
  var endCorrectionIndex = length;
  var firstText = text.substr(0, length);
  var secondText = text.substr(length);
  var beforeIndex = firstText.lastIndexOf(splitAtCharacter);
  var afterIndex = secondText.indexOf(splitAtCharacter);
  var isBeforeIndexFound = beforeIndex > -1;
  var isAfterIndexFound = afterIndex > -1;
  switch (splitAtCharacterCorrection) {
    case "before":
      endCorrectionIndex = isBeforeIndexFound ? beforeIndex : text.indexOf(splitAtCharacter);
      break;
    case "after":
      endCorrectionIndex = isAfterIndexFound ? length + afterIndex : text.indexOf(splitAtCharacter);
      break;
    case "auto":
    default:
      if (isBeforeIndexFound && (length - beforeIndex <= afterIndex || !isAfterIndexFound)) {
        endCorrectionIndex = beforeIndex;
      } else if (isAfterIndexFound) {
        endCorrectionIndex = length + afterIndex;
      }
      break;
  }
  if (endCorrectionIndex === -1) {
    return [text || ""];
  }
  var truncatedText = {
    shown: text.substring(0, endCorrectionIndex),
    hidden: text.substring(endCorrectionIndex)
  };
  return trimWhitespaces ? [truncatedText.shown.trim(), truncatedText.hidden.trim()] : [truncatedText.shown, truncatedText.hidden];
}
__name(splitText, "splitText");
var ExpandableText = /* @__PURE__ */ function(_Component) {
  function ExpandableText2(props) {
    var _this;
    _classCallCheck(this, ExpandableText2);
    _this = _callSuper(this, ExpandableText2, [props]);
    _this.state = {
      isOpened: false,
      wasDetectedAsMarkdown: ExpandableText2.shouldParseAsMarkdown(_this.props.isMarkdown, _this.props.children)
    };
    _this.handleExpand = _this.handleExpand.bind(_this);
    return _this;
  }
  __name(ExpandableText2, "ExpandableText");
  _inherits(ExpandableText2, _Component);
  return _createClass(ExpandableText2, [{
    key: "shouldComponentUpdate",
    value: (
      /**
       * shouldComponentUpdate
       * @param {Props} nextProps
       * @param {State} nextState
       */
      /* @__PURE__ */ __name(function shouldComponentUpdate(nextProps, nextState) {
        return this.state.isOpened !== nextState.isOpened || this.props.length !== nextProps.length || this.props.isMarkdown !== nextProps.isMarkdown || this.props.children !== nextProps.children;
      }, "shouldComponentUpdate")
    )
    /**
     * getDerivedStateFromProps
     *
     * @param {Props} props
     * @param {State} state
     * @returns {?Object}
     */
  }, {
    key: "handleExpand",
    value: (
      /**
       * handleExpand
       * @param {Object} e
       */
      /* @__PURE__ */ __name(function handleExpand(e) {
        e.preventDefault();
        var isOpened = this.state.isOpened;
        this.setState({
          isOpened: !isOpened
        });
      }, "handleExpand")
    )
    /**
     * render
     *
     * @returns {React$Element}
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$state = this.state, isOpened = _this$state.isOpened, wasDetectedAsMarkdown = _this$state.wasDetectedAsMarkdown;
      var _this$props = this.props, children = _this$props.children, length = _this$props.length, ellipsis = _this$props.ellipsis, customClassName = _this$props.customClassName, more = _this$props.more, less = _this$props.less, splitAtCharacterCorrection = _this$props.splitAtCharacterCorrection;
      var TRIM_WHITESPACES = true;
      var _splitText = splitText(children, length, wasDetectedAsMarkdown ? "\n" : " ", splitAtCharacterCorrection, wasDetectedAsMarkdown ? TRIM_WHITESPACES : false), _splitText2 = _slicedToArray(_splitText, 2), truncatedText = _splitText2[0], hiddenText = _splitText2[1];
      var showEllipsis = isOpened || !hiddenText;
      var ellipsysMarkup = showEllipsis || !ellipsis ? "" : "<span>".concat(ellipsis, "</span>");
      return /* @__PURE__ */ React.createElement("section", {
        className: ClassNames(expandableTextCls, customClassName)
      }, wasDetectedAsMarkdown ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Markdown, {
        text: truncatedText + (showEllipsis || !ellipsis ? "" : ellipsis)
      })) : /* @__PURE__ */ React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: nl2br(truncatedText + ellipsysMarkup)
        }
      }), hiddenText ? /* @__PURE__ */ React.createElement(React.Fragment, null, wasDetectedAsMarkdown ? /* @__PURE__ */ React.createElement("span", {
        className: ClassNames(_defineProperty({}, expandableTextHideCls, !isOpened))
      }, /* @__PURE__ */ React.createElement(Markdown, {
        text: hiddenText
      })) : /* @__PURE__ */ React.createElement("span", {
        className: ClassNames(_defineProperty({}, expandableTextHideCls, !isOpened)),
        dangerouslySetInnerHTML: {
          __html: nl2br(hiddenText)
        }
      }), /* @__PURE__ */ React.createElement("span", {
        className: expandableTextButtonsWrapperCls
      }, /* @__PURE__ */ React.createElement(Button, {
        type: "link",
        className: ClassNames(_defineProperty({}, expandableTextHideCls, isOpened)),
        onClick: this.handleExpand
      }, more), /* @__PURE__ */ React.createElement(Button, {
        type: "link",
        className: ClassNames(_defineProperty({}, expandableTextHideCls, !isOpened)),
        onClick: this.handleExpand
      }, less))) : null);
    }, "render")
  }], [{
    key: "shouldParseAsMarkdown",
    value: /* @__PURE__ */ __name(function shouldParseAsMarkdown(isMarkdown, children) {
      return !!(isMarkdown && isStringMarkdown(children));
    }, "shouldParseAsMarkdown")
  }, {
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function getDerivedStateFromProps(props, state) {
      var isDectedMarkdown = ExpandableText2.shouldParseAsMarkdown(props.isMarkdown, props.children);
      if (state.wasDetectedAsMarkdown !== isDectedMarkdown) {
        return {
          wasDetectedAsMarkdown: isDectedMarkdown
        };
      }
      return null;
    }, "getDerivedStateFromProps")
  }]);
}(Component);
_defineProperty(ExpandableText, "defaultProps", {
  ellipsis: "\u2026",
  length: 0,
  customClassName: null,
  isMarkdown: false,
  splitAtCharacterCorrection: "before"
});
export {
  ExpandableText
};
